import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
  // DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiBootstrap,
  DiJavascript,
} from "react-icons/di";
import {
  // SiFirebase,
  SiNextdotjs,
  SiDjango,
  SiMysql,
  SiPhp,
  SiHtml5,
  SiCss3,
  SiTypescript,
  SiTailwindcss,
  SiPostgresql,
  SiExpress,
  SiRedux,
  SiMui,
  SiAntdesign,
  SiPrisma,
  SiUpstash,
  SiRedis,
  SiPlotly,
  SiStreamlit,
} from "react-icons/si";

function Techstack({ text }) {
  const [showTextReact, setShowTextReact] = useState(false);
  const [showTextNodejs, setShowTextNodejs] = useState(false);
  const [showTextMongo, setShowTextMongo] = useState(false);
  const [showTextNext, setShowTextNext] = useState(false);
  const [showTextPython, setShowTextPython] = useState(false);
  const [showTextDjango, setShowTextDjango] = useState(false);
  const [showTextPhp, setShowTextPhp] = useState(false);
  const [showTextMysql, setShowTextMysql] = useState(false);
  const [showTextCplus, setShowTextCplus] = useState(false);
  const [showTextHtml, setShowTextHtml] = useState(false);
  const [showTextCss, setShowTextCss] = useState(false);
  const [showTextBootstrap, setShowTextBootstrap] = useState(false);
  const [showTextJavascript, setShowTextJavascript] = useState(false);
  const [showTextTypescript, setShowTextTypescript] = useState(false);
  const [showTextTailwindcss, setShowTextTailwindcss] = useState(false);
  const [showTextPostgreSql, setShowTextPostgreSql] = useState(false);
  const [showTextExpress, setShowTextExpress] = useState(false);
  const [showTextRedux, setShowTextRedux] = useState(false);
  const [showTextMui, setShowTextMui] = useState(false);
  const [showTextAntd, setShowTextAntd] = useState(false);
  const [showTextPrisma, setShowTextPrisma] = useState(false);
  const [showTextUpstash, setShowTextUpstash] = useState(false);
  const [showTextRedis, setShowTextRedis] = useState(false);
  const [showTextPlotly, setShowTextPlotly] = useState(false);
  const [showTextStreamlit, setShowTextStreamlit] = useState(false);

  const handleMouseEnterReact = () => {
    setShowTextReact(true);
  };

  const handleMouseLeaveReact = () => {
    setShowTextReact(false);
  };

  const handleMouseEnterNodejs = () => {
    setShowTextNodejs(true);
  };

  const handleMouseLeaveNodejs = () => {
    setShowTextNodejs(false);
  };
  const handleMouseEnterMongo = () => {
    setShowTextMongo(true);
  };

  const handleMouseLeaveMongo = () => {
    setShowTextMongo(false);
  };
  const handleMouseEnterNext = () => {
    setShowTextNext(true);
  };

  const handleMouseLeaveNext = () => {
    setShowTextNext(false);
  };

  const handleMouseEnterCplus = () => {
    setShowTextCplus(true);
  };

  const handleMouseLeaveCplus = () => {
    setShowTextCplus(false);
  };
  const handleMouseEnterBootstrap = () => {
    setShowTextBootstrap(true);
  };

  const handleMouseLeaveBootstrap = () => {
    setShowTextBootstrap(false);
  };
  const handleMouseEnterCss = () => {
    setShowTextCss(true);
  };

  const handleMouseLeaveCss = () => {
    setShowTextCss(false);
  };
  const handleMouseEnterHtml = () => {
    setShowTextHtml(true);
  };

  const handleMouseLeaveHtml = () => {
    setShowTextHtml(false);
  };
  const handleMouseEnterPython = () => {
    setShowTextPython(true);
  };

  const handleMouseLeavePython = () => {
    setShowTextPython(false);
  };
  const handleMouseEnterDjango = () => {
    setShowTextDjango(true);
  };

  const handleMouseLeaveDjango = () => {
    setShowTextDjango(false);
  };
  const handleMouseEnterPhp = () => {
    setShowTextPhp(true);
  };

  const handleMouseLeavePhp = () => {
    setShowTextPhp(false);
  };
  const handleMouseEnterMysql = () => {
    setShowTextMysql(true);
  };

  const handleMouseLeaveMysql = () => {
    setShowTextMysql(false);
  };
  const handleMouseEnterJavascript = () => {
    setShowTextJavascript(true);
  };

  const handleMouseLeaveJavascript = () => {
    setShowTextJavascript(false);
  };
  const handleMouseEnterTypescript = () => {
    setShowTextTypescript(true);
  };

  const handleMouseLeaveTypescript = () => {
    setShowTextTypescript(false);
  };
  const handleMouseEnterTailwindcss = () => {
    setShowTextTailwindcss(true);
  };

  const handleMouseLeaveTailwindcss = () => {
    setShowTextTailwindcss(false);
  };
  const handleMouseEnterPostgresql = () => {
    setShowTextPostgreSql(true);
  };

  const handleMouseLeavePostgresql = () => {
    setShowTextPostgreSql(false);
  };
  const handleMouseEnterExpress = () => {
    setShowTextExpress(true);
  };

  const handleMouseLeaveExpress = () => {
    setShowTextExpress(false);
  };
  const handleMouseEnterRedux = () => {
    setShowTextRedux(true);
  };

  const handleMouseLeaveRedux = () => {
    setShowTextRedux(false);
  };
  const handleMouseEnterMui = () => {
    setShowTextMui(true);
  };

  const handleMouseLeaveMui = () => {
    setShowTextMui(false);
  };
  const handleMouseEnterAntd = () => {
    setShowTextAntd(true);
  };

  const handleMouseLeaveAntd = () => {
    setShowTextAntd(false);
  };
  const handleMouseEnterPrisma = () => {
    setShowTextPrisma(true);
  };

  const handleMouseLeavePrisma = () => {
    setShowTextPrisma(false);
  };
  const handleMouseEnterUpstash = () => {
    setShowTextUpstash(true);
  };

  const handleMouseLeaveUpstash = () => {
    setShowTextUpstash(false);
  };
  const handleMouseEnterRedis = () => {
    setShowTextRedis(true);
  };

  const handleMouseLeaveRedis = () => {
    setShowTextRedis(false);
  };
  const handleMouseEnterPlotly = () => {
    setShowTextPlotly(true);
  };

  const handleMouseLeavePlotly = () => {
    setShowTextPlotly(false);
  };
  const handleMouseEnterStreamlit = () => {
    setShowTextStreamlit(true);
  };

  const handleMouseLeaveStreamlit = () => {
    setShowTextStreamlit(false);
  };

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterReact}
        onMouseLeave={handleMouseLeaveReact}
      >
        <DiReact />
        {showTextReact && <p className="tech-icons-text">React Js</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterNext}
        onMouseLeave={handleMouseLeaveNext}
      >
        <SiNextdotjs />
        {showTextNext && <p className="tech-icons-text">Next Js</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterNodejs}
        onMouseLeave={handleMouseLeaveNodejs}
      >
        <DiNodejs />
        {showTextNodejs && <p className="tech-icons-text">Node Js</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterExpress}
        onMouseLeave={handleMouseLeaveExpress}
      >
        <SiExpress />
        {showTextExpress && <p className="tech-icons-text">ExpressJs</p>}
      </Col>

      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterRedux}
        onMouseLeave={handleMouseLeaveRedux}
      >
        <SiRedux />
        {showTextRedux && <p className="tech-icons-text">Redux</p>}
      </Col>

      {/* <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterShadcn}
        onMouseLeave={handleMouseLeaveShadcn}
      >
        <SiShadcnui />
        {showTextShadcn && <p className="tech-icons-text">Shadcn UI</p>}
      </Col> */}
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterAntd}
        onMouseLeave={handleMouseLeaveAntd}
      >
        <SiAntdesign />
        {showTextAntd && <p className="tech-icons-text">AntDesign</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterMui}
        onMouseLeave={handleMouseLeaveMui}
      >
        <SiMui />
        {showTextMui && <p className="tech-icons-text">Material UI</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterTailwindcss}
        onMouseLeave={handleMouseLeaveTailwindcss}
      >
        <SiTailwindcss />
        {showTextTailwindcss && <p className="tech-icons-text">TailwindCSS</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterJavascript}
        onMouseLeave={handleMouseLeaveJavascript}
      >
        <DiJavascript />
        {showTextJavascript && <p className="tech-icons-text">Javascript</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterTypescript}
        onMouseLeave={handleMouseLeaveTypescript}
      >
        <SiTypescript />
        {showTextTypescript && <p className="tech-icons-text">Typescript</p>}
      </Col>

      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterMongo}
        onMouseLeave={handleMouseLeaveMongo}
      >
        <DiMongodb />
        {showTextMongo && <p className="tech-icons-text">Mongo DB</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterPrisma}
        onMouseLeave={handleMouseLeavePrisma}
      >
        <SiPrisma />
        {showTextPrisma && <p className="tech-icons-text">Prisma</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterUpstash}
        onMouseLeave={handleMouseLeaveUpstash}
      >
        <SiUpstash />
        {showTextUpstash && <p className="tech-icons-text">Upstash</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterRedis}
        onMouseLeave={handleMouseLeaveRedis}
      >
        <SiRedis />
        {showTextRedis && <p className="tech-icons-text">Redis</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterMysql}
        onMouseLeave={handleMouseLeaveMysql}
      >
        <SiMysql />
        {showTextMysql && <p className="tech-icons-text">MySql</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterPostgresql}
        onMouseLeave={handleMouseLeavePostgresql}
      >
        <SiPostgresql />
        {showTextPostgreSql && <p className="tech-icons-text">PostgreSQL</p>}
      </Col>

      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterPython}
        onMouseLeave={handleMouseLeavePython}
      >
        <DiPython />
        {showTextPython && <p className="tech-icons-text">Python</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterDjango}
        onMouseLeave={handleMouseLeaveDjango}
      >
        <SiDjango />
        {showTextDjango && <p className="tech-icons-text">Django</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterStreamlit}
        onMouseLeave={handleMouseLeaveStreamlit}
      >
        <SiStreamlit />
        {showTextStreamlit && <p className="tech-icons-text">Streamlit</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterPlotly}
        onMouseLeave={handleMouseLeavePlotly}
      >
        <SiPlotly />
        {showTextPlotly && <p className="tech-icons-text">Dash</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterPhp}
        onMouseLeave={handleMouseLeavePhp}
      >
        <SiPhp />
        {showTextPhp && <p className="tech-icons-text">Php</p>}
      </Col>

      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterHtml}
        onMouseLeave={handleMouseLeaveHtml}
      >
        <SiHtml5 />
        {showTextHtml && <p className="tech-icons-text">Html5</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterCss}
        onMouseLeave={handleMouseLeaveCss}
      >
        <SiCss3 />
        {showTextCss && <p className="tech-icons-text">CSS3</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterBootstrap}
        onMouseLeave={handleMouseLeaveBootstrap}
      >
        <DiBootstrap />
        {showTextBootstrap && <p className="tech-icons-text">Bootstrap</p>}
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterCplus}
        onMouseLeave={handleMouseLeaveCplus}
      >
        <CgCPlusPlus />
        {showTextCplus && <p className="tech-icons-text">C++</p>}
      </Col>
      {/* <Col
        xs={4}
        md={2}
        className="tech-icons"
        onMouseEnter={handleMouseEnterGit}
        onMouseLeave={handleMouseLeaveGit}
      >
        <DiGit />
        {showTextGit && <p className="tech-icons-text">Git Hub</p>}
      </Col> */}
      {/* <Col xs={4} md={2} className="tech-icons">
        <SiFirebase />
      </Col> */}
    </Row>
  );
}

export default Techstack;

//5DBFA8
